import { ID, TicketMessage } from "@project/shared-types";
import { Text } from "../../../components/texts/text";
import "./SupportMessage.css";

interface SupportMessageProps {
  message: TicketMessage;
  current_user_id: ID;
}
export const SupportMessage = ({
  message,
  current_user_id,
}: SupportMessageProps) => {
  return (
    <div
      className={`support-message-container ${message.user_id === current_user_id ? "answer-message" : ""
        }`}
    >
      <div className="support-message">
        <div className="support-message-content">
          <Text>{message.message}</Text>
        </div>
      </div>
    </div>
  );
};
